import React from "react";

const CONTACT_FORM_URL =
    "https://forms.zohopublic.com/fourminutemedicine1/form/Weareheretohelpcontactusanytime/formperma/hlFpw9eU9qi4D972ynkfVR6f-e4FsZgrhKqbr3iXEP4";

const ContactPage = () => {
    return (
        <main className="min-h-screen w-full bg-white">
            <iframe
                aria-label="We are here to help, contact us anytime!"
                frameBorder="0"
                src={CONTACT_FORM_URL}
                title="Contact us"
                className="h-screen w-full border-0"
                style={{ border: "none" }}
            />
        </main>
    );
};

export default ContactPage;
